module.exports = __webpack_public_path__ + "img/fluent_math-formula-24-filled.ddbda227.svg";